import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-location" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("button", {
        class: "buttonBase w-100 mb-2",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.locationSearch && _ctx.locationSearch(...args)))
    }, [
        _hoisted_1,
        _createTextVNode(" Mein Standort ")
    ]));
}
